import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../Logo';
import Button from '../../ui/Button';
import ThemeToggle from '../../theme/ThemeToggle';
import './Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setIsScrolled(window.scrollY > 20);
    }

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function scrollToSection(sectionId) {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Account for sticky navbar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }

  return (
    <nav className={`landing-navbar ${isScrolled ? 'landing-navbar--scrolled' : ''}`}>
      <div className="landing-navbar-content">
        <div className="landing-navbar-logo">
          <Logo size="small" />
        </div>

        <div className="landing-navbar-links">
          <button
            type="button"
            className="landing-navbar-link"
            onClick={() => scrollToSection('intro')}
          >
            Intro
          </button>
          <button
            type="button"
            className="landing-navbar-link"
            onClick={() => scrollToSection('about')}
          >
            About
          </button>
          <button
            type="button"
            className="landing-navbar-link"
            onClick={() => scrollToSection('contact')}
          >
            Contact
          </button>
        </div>

        <div className="landing-navbar-actions">
          <ThemeToggle />
          <Button
            variant="secondary"
            onClick={() => navigate('/signin')}
            className="landing-navbar-cta"
          >
            Sign in
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate('/signin')}
            className="landing-navbar-cta"
          >
            Try for Free
          </Button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
